<template>
  <div v-if="isFreeTrialCoupon">
    <FreeTrialCouponPlanSummaryCard />
  </div>
  <div v-else-if="isUpgrade">
    <UpgradeDiscountCouponPlanSummaryCard v-if="isDiscountCoupon" />
    <UpgradePlanSummaryCard v-else />
  </div>
  <div v-else-if="paymentRequired">
    <SetupFeePlanSummaryCard v-if="isPayOncePlan" />
    <DiscountCouponPlanSummaryCard v-else-if="isDiscountCoupon" />
    <DefaultPlanSummaryCard v-else />
  </div>
  <NoPayPlanSummaryCard v-else />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { useCouponStore } from '@/store/CouponStore'
import { usePlanStore } from '@/store/PlanStore'
import DiscountCouponPlanSummaryCard from '@/components/shared/plan-summary/DiscountCouponPlanSummaryCard.vue'
import FreeTrialCouponPlanSummaryCard from '@/components/shared/plan-summary/FreeTrialCouponPlanSummaryCard.vue'
import NoPayPlanSummaryCard from '@/components/shared/plan-summary/NoPayPlanSummaryCard.vue'
import DefaultPlanSummaryCard from '@/components/shared/plan-summary/DefaultPlanSummaryCard.vue'
import SetupFeePlanSummaryCard from '@/components/shared/plan-summary/SetupFeePlanSummaryCard.vue'
import UpgradePlanSummaryCard from '@/components/shared/plan-summary/UpgradePlanSummaryCard.vue'
import UpgradeDiscountCouponPlanSummaryCard from '@/components/shared/plan-summary/UpgradeDiscountCouponPlanSummaryCard.vue'
const planStore = usePlanStore()
const couponStore = useCouponStore()

const route = useRoute()
const { name } = route

const isUpgrade = computed(() => name === 'upgrade')

const { isPayOncePlan, paymentRequired } = storeToRefs(planStore)

const { isFreeTrialCoupon, isForeverCoupon, isTemporalCoupon, isSingleUseDiscountCoupon } = storeToRefs(couponStore)

const isDiscountCoupon = computed(() => isTemporalCoupon.value || isForeverCoupon.value || isSingleUseDiscountCoupon.value)
</script>
